var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ApolloClient, InMemoryCache, createHttpLink, } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
var CTK_STORAGE_KEY = "tmn-ctk";
var DO_NOT_TRACK_STORAGE_KEY = "tmn-dnt";
var DO_NOT_TRACK_DEFAULT = "1";
function getCtkFromLocalStorage() {
    try {
        return localStorage.getItem(CTK_STORAGE_KEY);
    }
    catch (_a) {
        return null;
    }
}
function getDoNotTrackFromLocalStorage() {
    var _a;
    try {
        return ((_a = localStorage.getItem(DO_NOT_TRACK_STORAGE_KEY)) !== null && _a !== void 0 ? _a : DO_NOT_TRACK_DEFAULT);
    }
    catch (_b) {
        // Default to Do Not Track if nothing is found
        return DO_NOT_TRACK_DEFAULT;
    }
}
export function getClient(uri, placementId) {
    var httpLink = createHttpLink({
        uri: uri || "/graphql",
        credentials: "include",
    });
    var ctkLink = setContext(function (_, _a) {
        var headers = _a.headers;
        var ctk = getCtkFromLocalStorage();
        var dnt = getDoNotTrackFromLocalStorage();
        return {
            headers: __assign(__assign(__assign(__assign({}, headers), (ctk && { "indeed-ctk": ctk })), (dnt && { "indeed-dnt": dnt })), (placementId && { "indeed-placementid": placementId })),
        };
    });
    return new ApolloClient({
        link: ctkLink.concat(httpLink),
        cache: new InMemoryCache(),
    });
}
